import { generateGetRaceId } from 'modules/racersTable/utils';

import { ROUTER_WITH_LOCALES } from 'src/constants';

const getRaceId = generateGetRaceId(ROUTER_WITH_LOCALES.RACE_START_LIST);

export { getRaceId };
